export class TokenBuffer {
  private buffer = '';
  private rafId: number | null = null;
  private onFlush: (content: string) => void;

  constructor(onFlush: (content: string) => void) {
    this.onFlush = onFlush;
  }

  append(content: string) {
    this.buffer += content;
    if (this.rafId === null) {
      this.rafId = requestAnimationFrame(() => {
        this.onFlush(this.buffer);
        this.rafId = null;
      });
    }
  }

  drain() {
    if (this.rafId !== null) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
    if (this.buffer) {
      this.onFlush(this.buffer);
      this.buffer = '';
    }
  }

  reset() {
    if (this.rafId !== null) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
    this.buffer = '';
  }
}
